// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"965dda1e","453":"d59e69a4"}[chunkId] + ".chunk.js";
};